<div class="app-header">
    <a [routerLink]="['/home']" class="app-logo"
        ><img class="app-logo-img" src="assets/form_neptune_logo.png" />
    </a>
    <div class="pull-right app-toolbar">
        <ul class="list-inline">
            <li class="list-inline-item">
                <app-selector></app-selector>
            </li>
            <li class="list-inline-item">
                <app-user-menu></app-user-menu>
            </li>
        </ul>
    </div>
</div>
